import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/goteborg")(
  heritageCityRoute({
    citySlug: "goteborg",
    angle:
      "I Göteborg och Västsverige hjälper vi familjer att bevara livsberättelser och västsvenska industri- och tech-bolag att dokumentera grundarhistoria, tyst kunskap och kultur innan generationsskiften.",
    localUseCases: [
      "Livsintervju med förälder eller släkting i Göteborg",
      "Grundarporträtt inom västsvensk industri",
      "Kunskapsöverföring i tillverknings- och life science-bolag",
      "Dokumentation av familjeägda bolag inför generationsskifte",
      "Företagshistoria för jubileum",
      "Minnesfilm och släktarv",
    ],
  }),
);
